(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Header-classic"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    class SotturaHeaderClassic {
      constructor() {
        this.mobileToggle = document.querySelector('.sottura-header-classic__mobile-toggle');
        this.mobileMenu = document.querySelector('[data-mobile-menu]');
        this.mobileOverlay = document.querySelector('[data-mobile-overlay]');
        this.mobileClose = document.querySelector('[data-close-menu]');
        this.accordionToggles = document.querySelectorAll('[data-submenu-toggle]');
        this.isMenuOpen = false;

        this.init();
      }

      init() {
        if (!this.mobileToggle || !this.mobileMenu) return;
        this.bindEvents();
      }

      bindEvents() {
        // Toggle menu
        this.mobileToggle.addEventListener('click', this.toggleMenu.bind(this));

        // Close menu with close button
        if (this.mobileClose) {
          this.mobileClose.addEventListener('click', this.closeMenu.bind(this));
        }

        // Close menu with overlay
        if (this.mobileOverlay) {
          this.mobileOverlay.addEventListener('click', this.closeMenu.bind(this));
        }

        // Accordion toggles
        this.accordionToggles.forEach(toggle => {
          toggle.addEventListener('click', this.handleAccordion.bind(this));
        });

        // Close menu on escape key
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isMenuOpen) {
            this.closeMenu();
          }
        });

        // Handle window resize
        window.addEventListener('resize', () => {
          if (this.isMenuOpen && window.innerWidth > 768) {
            this.closeMenu();
          }
        });
      }

      handleAccordion(e) {
        const toggle = e.currentTarget;
        const submenu = toggle.nextElementSibling;
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          // Close accordion
          toggle.setAttribute('aria-expanded', 'false');
          submenu.classList.remove('sottura-header-classic__mobile-submenu--open');
          submenu.style.display = 'none';
        } else {
          // Open accordion
          toggle.setAttribute('aria-expanded', 'true');
          submenu.style.display = 'block';
          // Delay adding class for animation
          setTimeout(() => {
            submenu.classList.add('sottura-header-classic__mobile-submenu--open');
          }, 10);
        }
      }

      toggleMenu() {
        if (this.isMenuOpen) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      }

      openMenu() {
        this.isMenuOpen = true;
        this.mobileToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        
        // Show overlay
        if (this.mobileOverlay) {
          this.mobileOverlay.classList.add('sottura-header-classic__mobile-overlay--visible');
        }
        
        // Show menu
        this.mobileMenu.classList.add('sottura-header-classic__mobile-menu--open');
      }

      closeMenu() {
        this.isMenuOpen = false;
        this.mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        
        // Hide overlay
        if (this.mobileOverlay) {
          this.mobileOverlay.classList.remove('sottura-header-classic__mobile-overlay--visible');
        }
        
        // Hide menu
        this.mobileMenu.classList.remove('sottura-header-classic__mobile-menu--open');
        
        // Close all accordions
        setTimeout(() => {
          this.accordionToggles.forEach(toggle => {
            const submenu = toggle.nextElementSibling;
            toggle.setAttribute('aria-expanded', 'false');
            submenu.classList.remove('sottura-header-classic__mobile-submenu--open');
            submenu.style.display = 'none';
          });
        }, 300);
      }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new SotturaHeaderClassic());
    } else {
      new SotturaHeaderClassic();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
